import { giphyDarkestGrey } from '@giphy/js-brand'
import { IGif } from '@giphy/js-types'
import { Button } from '@giphy/react-giphy-brand'
import download from 'downloadjs'
import React, { useContext, useEffect, useState } from 'react'
import sanitize from 'sanitize-filename'
import { fetchExtendedMetadata } from 'shared/api'
import UserContext from 'shared/components/context/user'
import styled from 'styled-components'

const Container = styled.div`
    align-items: center;
    background: ${giphyDarkestGrey};
    display: flex;
    font-size: 14px;
    font-weight: bold;
    padding: 10px 10px 10px 12px;
`

const Download = styled(Button)`
    border-radius: 2px;
    margin-left: auto;
`

const getHdUrl = ({ images = {} }: any) => {
    if (images.hd) {
        return images.hd.mp4
    }
    if (images.source?.url.indexOf('.mp4') > -1 || images.source?.url.indexOf('.mov') > -1) {
        return images.source.url
    }
    return null
}

type Props = {
    gif: IGif
}

const GifDetailDownloadBackdrop = ({ gif }: Props) => {
    const { user: loggedInUser } = useContext(UserContext)
    const [isEnabled, setIsEnabled] = useState<boolean>(false)
    const hdUrl = getHdUrl(gif)

    useEffect(() => {
        const fetchMetadata = async () => {
            const { extended_metadata = {} } = await fetchExtendedMetadata(gif.id)
            if (extended_metadata.tags && extended_metadata.tags.indexOf('giphybackdropmaker') > -1) {
                setIsEnabled(true)
            }
        }

        if (hdUrl && loggedInUser.isStaff) {
            fetchMetadata()
        }

        return () => {
            setIsEnabled(false)
        }
    }, [gif, loggedInUser])

    const onDownloadClick = async e => {
        e.preventDefault()

        // load asset and trigger download
        const gifUrl = `https://i.giphy.com/media/${gif.id}/giphy-hd.mp4`
        const result = await fetch(gifUrl)
        const blob = await result.blob()
        download(blob, sanitize(`${gif.title}-backdrop.mp4`))
    }

    return isEnabled ? (
        <Container>
            Use this background in Zoom Meetings!{' '}
            <Download as="a" href={hdUrl} onClick={onDownloadClick}>
                Download
            </Download>
        </Container>
    ) : null
}

export default GifDetailDownloadBackdrop
